import { Route, Navigate, Outlet } from "react-router-dom";
import React, { Suspense, lazy } from 'react';
import { ChatGpt } from './pages/ChatGPT';

import { CvWithRouter } from "./pages/Cv";
import {CvWithRouter2} from "./pages/Cv2.";
//import { Home } from "./components/Home";
//import { Login } from "./components/Login";
//import { Table2 } from "./components/Table2";
const Home = lazy(() => import('./pages/Home'));
const Login = lazy(() => import('./components/Login'));
const Table2 = lazy(() => import('./pages/Table2'));
const MyDraggableComponent = lazy(() => import('./pages/DragTest'));

//version 1
////uage
//<Route  path="/dashboard"  element={ <PrivateRoute>  <Dashboard /> </PrivateRoute>  } />
const PrivateRoute = ({ children }) => {
    const isAuthenticated = true;//localStorage.getItem("token") == null ? false : true;
    return isAuthenticated ? children : <Navigate to="/login" />;
};



//version 2 =>better choice
////usage :
//<Route element={<PrivateWrapper />}>
//    <Route path="/dashboard" element={<Dashboard />} />
//</Route>
const PrivateWrapper = () => {
    const isAuthenticated = true;//localStorage.getItem("token") == null ? false : true;
    return isAuthenticated ? <Outlet /> : <Navigate to="/login" />;
};



const AppRoutes = [
    { index: true, element: <PrivateRoute> <Home /></PrivateRoute> },
    { path: '/cv/:id/:fullName', element: <CvWithRouter /> },
    { path: '/cv2/:id/:fullName', element: <CvWithRouter2 /> },
    { path: '/login', element: <Login openAs="page" /> },
    { path: '/Table2', element: <Table2 /> },
    { path: '/ChatGpt', element: <ChatGpt /> },
    { path: '/MyDraggableComponent', element: <MyDraggableComponent /> },
];

export default AppRoutes;
